module.exports = __webpack_public_path__ + "img/Kronberg_BRELG167.f959942c.webp";